import { Box, styled } from '@mui/material'

const styles = {
  wrapper: {
    display: 'flex',
    minHeight: '100vh',
    height: '100%',
  },

  containerLeft: {
    display: 'flex',
    p: '2rem',
    width: {
      md: '50%',
      xs: '100%',
    },
    background: 'white',
  },
}

const RightContainer = styled(Box)(({ theme }) => ({
  marginLeft: '50%',
  position: 'fixed',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  background: theme.palette.primary.main,
  padding: '2rem',
  width: '50%',
}))

const Layout = ({ children, Image }: any) => {
  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.containerLeft}>{children}</Box>

      <RightContainer sx={{ display: { md: 'flex', xs: 'none' } }}>
        <Box component='img' src={Image} sx={{ maxWidth: '23.75rem' }} />
      </RightContainer>
    </Box>
  )
}

export default Layout
